import { Helmet } from 'react-helmet-async'

export const FairtradeFonts = () => (
  <Helmet>
    <link
      id="fairtrade-fonts__templates-fairtrade__link__l5"
      rel="preconnect"
      href="https://fonts.googleapis.com"
    />
    <link
      id="fairtrade-fonts__templates-fairtrade__link__l6"
      rel="preconnect"
      href="https://fonts.gstatic.com"
      crossOrigin="anonymous"
    />
    <link
      id="fairtrade-fonts__templates-fairtrade__link__l7"
      href="https://fonts.googleapis.com/css2?family=Alegreya+Sans:wght@400;500;600;700&display=swap"
      rel="stylesheet"
    />
  </Helmet>
)
